<template>
  <div>
    <van-empty description="暂无货品信息" v-if="dataList.length == 0" />
    <div class="salesList" v-else>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <BasicContainer
          ><Sales :dataList="dataList" @setScroll="setScroll"></Sales
        ></BasicContainer>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Sales from "./sales";
import { getSalesList } from "@/api/sales.js";
export default {
  data() {
    return {
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      gallery_scroll: 0,
      isLoading: false,
    };
  },
  components: {
    Sales,
  },
  created() {
    this.getData();
  },
  mounted() {
    window.onscroll = () => {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.gallery_scroll = scrollTop;
    };
  },
  activated() {
    const gallery_scroll = localStorage.getItem("gallery_scroll");
    document.body.scrollTop = gallery_scroll;
    document.documentElement.scrollTop = gallery_scroll;
  },
  methods: {
    async getData() {
      const customerPhone = window.localStorage.getItem("phoneNumber");
      const result = await getSalesList({
        page: this.pageIndex,
        size: this.pageSize,
        customerPhone,
      });
      this.dataList = result.data.data.list;
    },
    async onRefresh() {
      await this.getData();
      this.isLoading = false;
    },
    setScroll() {
      localStorage.setItem("gallery_scroll", this.gallery_scroll);
    },
  },
};
</script>

<style lang="less" scoped>
.salesList {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 100vh;
}
::v-deep .container {
  margin-top: 40px;
}
</style>
